/* eslint-disable no-underscore-dangle */
/* eslint-disable max-classes-per-file */
import { MarkerType } from './Marker.constants';

const { STATIC, PROPERTY, SEARCH_POINT } = MarkerType;

export default class MarkerModel {
  constructor(data) {
    this._validate(data);
    const { lat, lng, id, type, timeZone } = data;
    this.lat = lat;
    this.lng = lng;
    this.id = id;
    this.type = type;
    this.timeZone = timeZone;
  }

  _requiredValidationMessage = prop =>
    `Unable to create marker model. Property '${prop}' is required.`;

  _validateId = id => {
    if (!id) throw new Error(this._requiredValidationMessage('id'));
  };

  _validateLat = lat => {
    if (!lat && lat !== 0) throw new Error(this._requiredValidationMessage('lat'));
  };

  _validateLng = lng => {
    if (!lng && lng !== 0) throw new Error(this._requiredValidationMessage('lng'));
  };

  _validateType = type => {
    if (!type) throw new Error(this._requiredValidationMessage('type'));
  };

  _validate(data) {
    const { lat, lng, id, type } = data;
    this._validateId(id);
    this._validateLat(lat);
    this._validateLng(lng);
    this._validateType(type);
  }

  getPosition() {
    return [this.lat, this.lng];
  }

  isOfType(type) {
    return this.type === type;
  }
}

export class MapLayerMarkerModel extends MarkerModel {
  constructor(data) {
    super(data);
    const { label } = data;
    this.label = label;
  }

  _validateLabel(label) {
    if (!label) throw new Error(this._requiredValidationMessage('label'));
  }

  _validate(data) {
    super._validate(data);
    const { label } = data;
    this._validateLabel(label);
  }
}

export class PropertyMarkerModel extends MarkerModel {
  constructor(data) {
    super({ ...data, type: PROPERTY });
    const {
      imgSrc,
      imgAlt,
      label,
      price,
      ceilingPrice,
      priceValue,
      priceType,
      ceilingPriceValue,
      currency,
      description,
      active,
      featured,
      favourite,
      slug,
      callForPricing,
      connected,
      // connected stuff
      strikeoutPrice,
      availability,
      // ceiling params
      ceilingMaxMarkup,
      ceilingMaxTrigger,
      ceilingGDSMarkup,
      timeZone,
      isOutOfPolicy,
    } = data;
    this.imgSrc = imgSrc;
    this.imgAlt = imgAlt;
    this.label = label;
    this.price = price;
    this.ceilingPrice = ceilingPrice;
    this.priceValue = priceValue;
    this.priceType = priceType;
    this.ceilingPriceValue = ceilingPriceValue;
    this.ceilingMaxMarkup = ceilingMaxMarkup;
    this.ceilingMaxTrigger = ceilingMaxTrigger;
    this.ceilingGDSMarkup = ceilingGDSMarkup;
    this.timeZone = timeZone;
    this.currency = currency;
    this.description = description;
    this.active = active;
    this.featured = featured;
    this.favourite = favourite;
    this.slug = slug;
    this.callForPricing = callForPricing;
    this.connected = connected;
    this.availability = availability;
    this.strikeoutPrice = strikeoutPrice;
    this.isOutOfPolicy = isOutOfPolicy;
  }
}

export class PropertyDetailMarkerModel extends MapLayerMarkerModel {
  constructor(data) {
    super({ ...data, type: STATIC });
  }
}

export class SearchPointMarkerModel extends MapLayerMarkerModel {
  constructor(data) {
    super({ ...data, type: SEARCH_POINT });
  }
}
